import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api } from '../../app/api'
const token = localStorage.getItem('token')
export const fetchNews = createAsyncThunk(
    'news/fetchNews',
    async () => {
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        const response = await api.get('/news')
        return response.data
    }
)
export const fetchCurrentNews = createAsyncThunk(
    'news/fetchCurrentNews',
    async (id) => {
        const response = await api.get(`/news/${id}`)
        return response.data
    }
)
export const searchNews = createAsyncThunk(
    'news/searchNews',
    async (search) => {
        const response = await api.get(`news-search?q=${search}`)
        return response.data
    }
)

export const addLike = createAsyncThunk(
    'news/addLike',
    async (id) => {
        const response = await api.patch(`/news/${id}/like`)
        return response.data
    }
)

export const addShareCount = createAsyncThunk(
    'news/addShareCount',
    async (id) => {
        const response = await api.post(`/news/${id}/share`)
        return response.data
    }
)

const newsSlice = createSlice({
    name: 'news',
    initialState: {
        isLoaded: false,
        currentNews: {},
        news: [],
        error: {
            failed: false,
            message: null,
        },
    },
    extraReducers: {
        [fetchNews.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchNews.fulfilled]: (state, action) => {
            state.news = action.payload
            state.isLoaded = true;
        },
        [fetchNews.rejected]: (state, action) => {
            state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [searchNews.pending]: (state) => {
            // state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [searchNews.fulfilled]: (state, action) => {
            state.news = action.payload
            // state.isLoaded = true;
        },
        [searchNews.rejected]: (state, action) => {
            // state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchCurrentNews.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchCurrentNews.fulfilled]: (state, action) => {
            state.currentNews = action.payload
            state.isLoaded = true;
        },
        [fetchCurrentNews.rejected]: (state, action) => {
            state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [addLike.fulfilled]: (state, action) => {
            state.currentNews = action.payload
        },
        [addShareCount.fulfilled]: (state, action) => {
            state.currentNews = action.payload
        }
    }
})

export default newsSlice.reducer
